@use 'config' as config;

:host {
  position: relative;

  .canvas {
    display: flex;
    padding: 0.25rem 0;
    overflow-x: auto;
    gap: 0.25rem;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::before,
    &::after {
      content: '';
      flex-grow: 1;
    }

    @media only screen and (max-width: 639px) {
      display: none;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    ::slotted(*) {
      flex-shrink: 0;
      height: 6.25rem;
      cursor: pointer;
      aspect-ratio: 1.66;
    }

    ::slotted([data-active]) {
      border: solid 1px config.$preview-selected-color;
    }

    &[data-dragging],
    &[data-dragging] ::slotted(*) {
      cursor: grabbing;
    }
  }
}
